import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl } from "../../../../helper/urls";
import { useSelector } from "react-redux";

const EditStudent = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country_code: "",
    schoolName: "",
    currentGrade: "",
  });

  const fetchStudent = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/students/getStudent/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data.data;

      setFormData({
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        phone: data.phone || "",
        country_code: data.country_code || "",
        schoolName: data.schoolName || "",
        currentGrade: data.currentGrade || "",
      });
    } catch (error) {
      toast.error("Failed to fetch student data.");
      console.error("Error fetching student data:", error);
    }
  };

  // ✅ Fetch existing student data
  useEffect(() => {
    if (id) {
      fetchStudent();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value, country) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
      country_code: `+${country.dialCode}`,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const updatePayload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        schoolName: formData.schoolName,
        currentGrade: formData.currentGrade,
        email: formData.email,
        phone: formData.phone,
        country_code: formData.country_code,
      };

      const response = await axios.put(
        `${baseUrl}/api/students/update/${id}`,
        updatePayload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success(
          response.data.data.message || "Student updated successfully!"
        );
        navigate("/all-students");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update student");
      console.error("Error updating student:", error);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card h-100 p-0 radius-12">
        <div className="row justify-content-center">
          <div className="col-xxl-12 col-xl-12 col-lg-12">
            <div className="card border">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 mb-20">
                      <label htmlFor="firstName" className="form-label">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="firstName"
                        name="firstName"
                        placeholder="Enter First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label htmlFor="lastName" className="form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="lastName"
                        name="lastName"
                        placeholder="Enter Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label htmlFor="email" className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control radius-8"
                        id="email"
                        name="email"
                        placeholder="Enter Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label htmlFor="phone" className="form-label">
                        Phone <span className="text-danger">*</span>
                      </label>
                      <div className="custom-phone-input-wrapper">
                        <PhoneInput
                          country={"us"}
                          value={formData.phone}
                          onChange={handlePhoneChange}
                          inputProps={{
                            required: true,
                            name: "phone",
                            className: "form-control radius-8",
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label htmlFor="schoolName" className="form-label">
                        School Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="schoolName"
                        name="schoolName"
                        placeholder="Enter School Name"
                        value={formData.schoolName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-sm-6 mb-20">
                      <label htmlFor="currentGrade" className="form-label">
                        Current Grade <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="currentGrade"
                        name="currentGrade"
                        placeholder="Enter Current Grade"
                        value={formData.currentGrade}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-end gap-3 mt-4">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
          .custom-phone-input-wrapper .form-control {
            width: 100% !important;
            height: 45px;
            font-size: 16px;
          }

          .custom-phone-input-wrapper .flag-dropdown {
            height: 100%;
            border-radius: 8px 0 0 8px;
          }

          @media (max-width: 768px) {
            .custom-phone-input-wrapper .form-control {
              height: 40px;
              font-size: 14px;
            }
          }

          @media (max-width: 576px) {
            .custom-phone-input-wrapper .form-control {
              height: 36px;
              font-size: 13px;
            }
          }
        `}</style>
    </>
  );
};

export default EditStudent;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import { toast, ToastContainer } from "react-toastify";
// import { baseUrl } from "../../../../helper/urls";

// const EditStudent = () => {
//   const { token } = useSelector((state) => state.auth);
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     country_code: "",
//     schoolName: "",
//     currentGrade: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handlePhoneChange = (value, country) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       phone: value,
//       country_code: `+${country.dialCode}`,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const headers = {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const updatePayload = {
//         firstName: formData.firstName,
//         lastName: formData.lastName,
//         schoolName: formData.schoolName,
//         currentGrade: formData.currentGrade,
//         email: formData.email,
//         phone: formData.phone,
//         country_code: formData.country_code,
//       };
//       const response = await axios.put(
//         `${baseUrl}/api/students/${studentData.id}`,
//         updatePayload,
//         {
//           headers,
//         }
//       );

//       if (response.status === 200) {
//         toast.success(
//           response.data.data.message || "Student saved successfully!"
//         );
//         navigate("/all-students");
//       }
//     } catch (error) {
//       toast.error(error.msg);
//       console.error("Error submitting student:", error);
//     }
//   };
//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="row justify-content-center">
//           <div className="col-xxl-12 col-xl-12 col-lg-12">
//             <div className="card border">
//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row">
//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="firstName" className="form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control radius-8"
//                         id="firstName"
//                         name="firstName"
//                         placeholder="Enter First Name"
//                         value={formData.firstName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="lastName" className="form-label">
//                         Last Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control radius-8"
//                         id="lastName"
//                         name="lastName"
//                         placeholder="Enter Last Name"
//                         value={formData.lastName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="email" className="form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="email"
//                         className="form-control radius-8"
//                         id="email"
//                         name="email"
//                         placeholder="Enter Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="phone" className="form-label">
//                         Phone <span className="text-danger">*</span>
//                       </label>
//                       <div className="custom-phone-input-wrapper">
//                         <PhoneInput
//                           country={"us"}
//                           value={formData.phone}
//                           onChange={handlePhoneChange}
//                           inputProps={{
//                             required: true,
//                             name: "phone",
//                             className: "form-control radius-8",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="schoolName" className="form-label">
//                         School Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control radius-8"
//                         id="schoolName"
//                         name="schoolName"
//                         placeholder="Enter School Name"
//                         value={formData.schoolName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     <div className="col-sm-6 mb-20">
//                       <label htmlFor="currentGrade" className="form-label">
//                         Current Grade <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control radius-8"
//                         id="currentGrade"
//                         name="currentGrade"
//                         placeholder="Enter Current Grade"
//                         value={formData.currentGrade}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="d-flex justify-content-end gap-3 mt-4">
//                     <button type="submit" className="btn btn-primary">
//                       Save
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <style>{`
//         .custom-phone-input-wrapper .form-control {
//           width: 100% !important;
//           height: 45px;
//           font-size: 16px;
//         }

//         .custom-phone-input-wrapper .flag-dropdown {
//           height: 100%;
//           border-radius: 8px 0 0 8px;
//         }

//         @media (max-width: 768px) {
//           .custom-phone-input-wrapper .form-control {
//             height: 40px;
//             font-size: 14px;
//           }
//         }

//         @media (max-width: 576px) {
//           .custom-phone-input-wrapper .form-control {
//             height: 36px;
//             font-size: 13px;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default EditStudent;
